import React from 'react'
import { FaTimes } from 'react-icons/fa/index';

interface Props {
    style?: React.CSSProperties
    color?: string,
    onHide: {() : void},
    label: string
};

export default class Panel extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { style, label } = this.props;

    return (
        <div className='junit-badge' style={{...style}} >
            <div>
                { label }
                <FaTimes size='1.25rem' style={{marginLeft: '0.25rem', cursor: 'pointer'}} onClick={this.props.onHide}/>
            </div>
        </div>
    );
  }
}